<template>
  <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.edit_role')">
    <FKBreadCrumbItem :page="$t('page.roles')" to="/system-roles" />
  </FKBreadCrumb>
  <RoleForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import RoleForm from "@/components/FK/Roles/RoleForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { RoleInfo } from "@/utils/models/user.model";

export default defineComponent({
  name: "UpdateRolePage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    RoleForm,
  },
  computed: {
    role(): RoleInfo { return this.$route.meta.role as RoleInfo}
  }
});
</script>